<template>
  <div class="home">
    <LoaderComponent v-show="loading" />
    <HeaderView />
    <section
      class="order-page-main-sec agency-design-grid-right media-links-summary-page-main-sec"
    >
      <div class="desktop-respovsive-main-sec">
        <div class="media-links-content">
          <div class="back-to-order">
          <button type="button" class="back-btn" @click="goBackToMediaLinks">
            <i class="fas fa-arrow-left"></i>
            Back To Media Links
          </button>
        </div>
          <h2 class="text-heading">Media Placement</h2>
          <div class="text-1">
            Media placement offering allows you to select one or multiple media sites to publish your destination URL. Simply select the media sites you want us to target, share your destination URLs with us and let us do the magic to bring you the traffic you desire.          </div>
          <div class="draft-autosave-text" :class="{ 'order-title-error': validation.order_title }">
            <input
              type="text"
              class="form-control"
              :class="{ 'has-error border-danger': validation.order_title }"
              id="mediaLinksOrderTitleInput"
              maxlength="100"
              placeholder="Add any title here, that will help you track this order later"
              v-model="form.order_title"
            />
          </div>
        </div>
        <div class="editor-dashboard-sec-2 media-links-table-sec">
          <div class="media-links-rows">
            <div
              v-for="(media, index) in mediaRows"
              :key="`${media.site}-${index}`"
              class="media-link-card"
              :class="{ 'is-selected-row': media.selected }"
            >
              <div class="media-meta-grid">
                <div class="meta-item">
                  <span class="meta-label">Media Site:</span>
                  <a
                    :href="getMediaSiteUrl(media.site)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="meta-value media-site-link"
                    v-b-tooltip.hover.top="media.site"
                  >
                    <span class="media-site-text">{{ media.site }}</span>
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                </div>
                <div class="meta-item">
                  <span class="meta-label">Type of Website:</span>
                  <span class="meta-value">{{ media.type_of_website || media.website_type || "--" }}</span>
                </div>
                <!-- <div class="meta-item">
                  <span class="meta-label">Rel Attribute:</span>
                  <span class="meta-value">{{ media.rel_attribute || "--" }}</span>
                </div> -->
                <div class="meta-item">
                  <span class="meta-label">Sponsored Tag:</span>
                  <span class="meta-value">{{ media.sponsored_tag || "--" }}</span>
                </div>
                <div class="meta-item">
                  <span class="meta-label">Price:</span>
                  <span class="meta-value">${{ formatPrice(media.price) }}</span>
                </div>
              </div>

              <div class="inputs-actions-row">
                <div class="input-group destination-input-group">
                  <label>Destination URL</label>
                  <input
                    v-model="media.destinationUrl"
                    type="text"
                    class="form-control"
                    :class="{ 'has-error border-danger': media.validation?.destinationUrl }"
                    placeholder="https://"
                  />
                </div>

                <div class="input-group anchor-input-group">
                  <label>Anchor Text</label>
                  <input
                    v-model="media.anchorText"
                    type="text"
                    class="form-control"
                    :class="{ 'has-error border-danger': media.validation?.anchorText }"
                    placeholder="Enter Anchor Text"
                  />
                </div>

                <div class="card-actions">
                  <button
                    type="button"
                    class="card-menu-btn"
                    @click="toggleRowMenu(index)"
                  >
                    <i class="fas fa-ellipsis-v"></i>
                  </button>

                  <div
                    v-if="openMenuIndex === index"
                    class="card-menu-dropdown"
                  >
                    <button type="button" @click="copyUrlToAllSites(index)">
                      Copy URL to All Site
                    </button>
                    <button v-if="mediaRows.length > 1" type="button" class="danger" @click="deleteRow(index)">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="btn-box-list">
            <a
              href="javascript:;"
              class="btn-3"
              @click="saveDraftOrder('custom')"
            >
              Save to Draft
            </a>
          </div>
        </div>
      </div>

    </section>

    <div class="new-product-page-btn-box medialinks-view-page-btn-box">
                 <!-- Action Buttons Section -->
              <!-- Order Summary Section -->
                <div class="order-summary-section">
                    <div class="summary-left">
                        <div class="total-links-text">Total Media {{ selectedMediaRows.length <= 1 ? "Link" : "Links" }}:
                          <span class="total-links-value">{{ selectedMediaRows.length }}</span>
                        </div>
                    </div>
                    <div class="summary-right">
                        <div class="total-amount">
                            <span class="total-label">Total</span>
                            <span class="total-value">USD ${{ selectedMediaTotalDisplay }}</span>
                        </div>
                        <button class="btn-proceed-payment" type="button" :disabled="!selectedMediaRows.length" @click="goToPayment">
                          Proceed to Payment
                        </button>
                    </div>
                </div>
              </div>

  </div>
</template>

<script>
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import { numberFormat } from "@/prod.js";
import LZString from "lz-string";
import swal from "sweetalert2";
import moment from "moment";
import { useToast } from "vue-toastification";
import { getDraftInvoiceReady } from "@/utils/draftOrderPayValidation.js";
const toast = useToast();
export default {
  components: {
    HeaderView,
    LoaderComponent,
  },

  async mounted() {
    this.draft_order_id = this.$route?.params?.id || null;
    this.resetSummaryFormState();
    if (this.draft_order_id) {
      localStorage.setItem("draft-order-id", this.draft_order_id);
      await this.getDraftOrder(this.draft_order_id);
    } else {
      // Fresh flow from Media Links selection should not auto-load an old draft.
      localStorage.removeItem("draft-order-id");
      if (!this.applyMediaLinksDataFromWebsite()) {
        this.loadSelectedMediaRows();
      }
    }
    this.timer = setInterval(() => {
      this.saveDraftOrder();
    }, 20000);
  },
  async activated() {
    this.resetSummaryFormState();
    this.draft_order_id = this.$route?.params?.id || null;
    if (this.draft_order_id) {
      localStorage.setItem("draft-order-id", this.draft_order_id);
      await this.getDraftOrder(this.draft_order_id);
    } else {
      localStorage.removeItem("draft-order-id");
      if (!this.applyMediaLinksDataFromWebsite()) {
        this.loadSelectedMediaRows();
      }
    }
  },
  data() {
    return {
      numberFormat,
      loading: false,
      form: {
        order_title: "",
      },
      validation: {
        order_title: false,
      },
      openMenuIndex: null,
      mediaRows: [],
      timer: null,
      currentDate: moment(new Date()).format("DD/MM/YYYY"),
      draft_order_id: null,
      order_type: "media_placement",
      medium: "direct",
      source: "direct",
      package_id: 0,
    };
  },
  methods: {
    isUserEmailVerified() {
      const authData = this.$store?.state?.Auth?.user?.data || {};
      return authData?.is_email_verified === true;
    },
    async ensureUserIsVerifiedBeforeProceed() {
      if (this.isUserEmailVerified()) return true;
      try {
        await this.$store.dispatch("Auth/getUserDataAction");
      } catch {
        // ignore refresh failure; fallback to current store state
      }
      if (this.isUserEmailVerified()) return true;
      await swal.fire({
        icon: "warning",
        text: "Please verify your email!",
      });
      return false;
    },
    toAmount(value) {
      const normalized = String(value ?? "")
        .replace(/,/g, "")
        .trim();
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    formatPrice(value) {
      return this.numberFormat(this.toAmount(value)) || "0.00";
    },
    resolvePrimaryCategory(row, baseCost) {
      const rawId =
        row?.category_id ??
        row?.category?.id ??
        row?.primary_category?.id ??
        row?.selected_category ??
        null;
      const normalizedId =
        rawId === "" || rawId === undefined || rawId === null ? null : Number(rawId);
      const categoryId = Number.isFinite(normalizedId) ? normalizedId : null;

      const categoryName = String(
        row?.category_name ??
          row?.category?.name ??
          row?.primary_category?.name ??
          row?.niche ??
          ""
      ).trim();

      return {
        id: categoryId,
        name: categoryName,
        cost: baseCost,
        product_cost: 0,
        total_cost: baseCost,
        special: 0,
      };
    },
    resetSummaryFormState() {
      // Open summary with empty fields every time.
      this.form.order_title = "";
      this.validation.order_title = false;
      this.openMenuIndex = null;
    },
    getQueryParameterValue(parameterName) {
      const fromRoute = this.$route?.query?.[parameterName];
      if (fromRoute != null && fromRoute !== "") {
        return Array.isArray(fromRoute) ? fromRoute[0] : fromRoute;
      }
      const queryString = location.search.substring(1);
      const queryParams = queryString.split("&");
      for (let i = 0; i < queryParams.length; i++) {
        const eq = queryParams[i].indexOf("=");
        const key = eq === -1 ? queryParams[i] : queryParams[i].substring(0, eq);
        if (key === parameterName) {
          const raw = eq === -1 ? "" : queryParams[i].substring(eq + 1);
          return decodeURIComponent(raw || "");
        }
      }
      return null;
    },
    // Website deep-link: ?media_links_data=<base64 JSON> (same pattern as ProductPage ?order=)
    // Payload should carry the same media-row fields we show + need for payment.
    applyMediaLinksDataFromWebsite() {
      const encoded = this.getQueryParameterValue("media_links_data");
      if (!encoded) return false;
      try {
        const parsed = JSON.parse(atob(encoded));
        const orderTitle = !Array.isArray(parsed)
          ? parsed?.order_title || parsed?.orderTitle || ""
          : "";
        const rows = Array.isArray(parsed)
          ? parsed
          : parsed?.links ||
            parsed?.media ||
            parsed?.data ||
            parsed?.media_links ||
            [];

        if (orderTitle) {
          this.form.order_title = String(orderTitle);
        }

        this.mediaRows = (Array.isArray(rows) ? rows : []).map((row) => {
          const price = this.toAmount(
            row?.client_fee ?? row?.price ?? row?.link_price ?? row?.custom_price ?? row?.total ?? 0
          );
          const site = row?.site ?? row?.media_site ?? row?.website ?? "--";
          const typeOfWebsite =
            row?.type_of_website ?? row?.website_type ?? row?.typeOfWebsite ?? "--";
          const categoryId =
            row?.category_id ??
            row?.category?.id ??
            row?.primary_category?.id ??
            row?.selected_category ??
            null;
          const categoryName =
            row?.category_name ??
            row?.category?.name ??
            row?.primary_category?.name ??
            row?.niche ??
            "";

          return {
            // Same shape as media-placements-selected + payment fields
            id: row?.id ?? row?.website_id ?? null,
            product_id: row?.product_id ?? row?.product?.id ?? null,
            site,
            da: row?.da ?? row?.authority ?? row?.exact_da_dr ?? row?.exact_da ?? "--",
            da_numeric: row?.da_numeric ?? null,
            traffic: row?.traffic ?? "--",
            location: row?.location ?? row?.location_label ?? "",
            location_label: row?.location_label ?? row?.location ?? "",
            sample_post:
              row?.sample_post ??
              row?.sample_post_href ??
              row?.sample_post_display ??
              "",
            sample_post_display: row?.sample_post_display ?? row?.sample_post ?? "",
            sample_post_href: row?.sample_post_href ?? null,
            turnaround_time:
              row?.turnaround_time ?? row?.turn_around_time ?? row?.tat ?? "--",
            industry:
              row?.industry ??
              row?.industry_name ??
              row?.niche ??
              (categoryName || "--"),
            niche: row?.niche ?? (categoryName || ""),
            rel_attribute: row?.rel_attribute ?? row?.relAttributes ?? row?.rel ?? "--",
            sponsored_tag:
              row?.sponsored_tag ?? row?.sponsoredTag ?? row?.sponsored ?? row?.tag ?? "--",
            type_of_website: typeOfWebsite,
            website_type: row?.website_type ?? typeOfWebsite,
            website_type_id: row?.website_type_id ?? null,
            website_type_tags: row?.website_type_tags ?? null,
            countries: row?.countries ?? null,
            category_id: categoryId,
            category_name: categoryName,
            price: price.toFixed(2),
            client_fee: price,
            // Prefill from website
            destinationUrl:
              row?.destinationUrl ?? row?.destination_url ?? row?.url ?? "",
            anchorText:
              row?.anchorText ?? row?.anchor_text ?? row?.text ?? row?.anchor ?? "",
            selected: true,
            validation: {
              destinationUrl: false,
              anchorText: false,
            },
          };
        });

        this.persistSelectedMediaRows();
        return this.mediaRows.length > 0;
      } catch {
        return false;
      }
    },
    persistSelectedMediaRows() {
      localStorage.setItem("media-placements-selected", JSON.stringify(this.mediaRows || []));
    },
    loadSelectedMediaRows() {
      try {
        const parsed = JSON.parse(localStorage.getItem("media-placements-selected") || "[]");
        this.mediaRows = (Array.isArray(parsed) ? parsed : []).map((row) => ({
          ...row,
          destinationUrl: "",
          anchorText: "",
          selected: true,
          validation: {
            destinationUrl: false,
            anchorText: false,
          },
        }));
      } catch (e) {
        this.mediaRows = [];
      }
    },
    hydrateMediaRowsFromDraftLinks(links = []) {
      this.mediaRows = (Array.isArray(links) ? links : []).map((row) => ({
        id: row?.website_id ?? row?.id ?? null,
        product_id: row?.product_id ?? row?.product?.id ?? null,
        site: row?.media_site ?? row?.site ?? "--",
        da: row?.exact_da_dr ?? row?.exact_da ?? row?.authority ?? row?.da ?? "--",
        traffic: row?.traffic ?? "--",
        location: (() => {
          const lbl = row?.location_label;
          if (lbl != null && String(lbl).trim() !== "") return String(lbl).trim();
          const loc = row?.location;
          if (typeof loc === "string") return String(loc).trim();
          if (loc && typeof loc === "object") {
            return String(
              loc.name ||
                loc.label ||
                loc.state ||
                loc.region ||
                loc.title ||
                loc.city ||
                ""
            ).trim();
          }
          return loc != null ? String(loc).trim() : "";
        })(),
        sample_post:
          row?.sample_post ??
          row?.sample_post_href ??
          row?.sample_post_display ??
          "",
        sample_post_display: row?.sample_post_display ?? row?.sample_post ?? "",
        sample_post_href: row?.sample_post_href ?? null,
        turnaround_time:
          row?.turnaround_time ??
          row?.turn_around_time ??
          row?.tat ??
          "--",
        industry:
          row?.industry ??
          row?.industry_name ??
          row?.niche ??
          row?.category_name ??
          row?.primary_category?.name ??
          "--",
        rel_attribute: row?.rel_attribute ?? "--",
        sponsored_tag: row?.sponsored_tag ?? row?.tag ?? "--",
        type_of_website: row?.type_of_website ?? row?.website_type ?? "--",
        website_type: row?.website_type ?? row?.type_of_website ?? "--",
        price: this.toAmount(row?.link_price ?? row?.custom_price ?? row?.total ?? 0).toFixed(2),
        client_fee: this.toAmount(row?.link_price ?? row?.custom_price ?? row?.total ?? 0),
        category_id:
          row?.category_id ??
          row?.primary_category?.id ??
          row?.selected_category ??
          null,
        category_name:
          row?.category_name ??
          row?.primary_category?.name ??
          row?.niche ??
          "",
        niche: row?.category_name ?? row?.primary_category?.name ?? row?.niche ?? "",
        destinationUrl: row?.destination_url ?? row?.url ?? "",
        anchorText: row?.anchor_text ?? row?.text ?? "",
        selected: true,
        validation: {
          destinationUrl: false,
          anchorText: false,
        },
      }));
    },
    async getDraftOrder(id) {
      this.loading = true;
      try {
        const res = await this.$store.dispatch("Link/getEditLinksDataAction", id);
        if (res?.draft_order) {
          this.draft_order_id = res.draft_order.id;
          localStorage.setItem("draft-order-id", res.draft_order.id);
          this.form.order_title = res.draft_order.order_title || "";
          const parsedLinks = JSON.parse(res.draft_order.links || "[]");
          this.hydrateMediaRowsFromDraftLinks(parsedLinks);
        } else {
          this.mediaRows = [];
          swal.fire({
            icon: "error",
            text: "Draft Order Already Deleted",
          });
        }
      } catch (e) {
        this.mediaRows = [];
        if (e?.response?.data?.error === "Access Denied") {
          localStorage.removeItem("draft-order-id");
          this.$router.push("/dashboard");
        }
      } finally {
        this.loading = false;
      }
    },
    getMediaSiteUrl(site) {
      if (!site) return "#";
      return /^https?:\/\//i.test(site) ? site : `https://${site}`;
    },
    isValidURL(value) {
      const normalized = this.normalizeDestinationUrl(value);
      if (!normalized) return false;
      try {
        const parsed = new URL(normalized);
        if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
          return false;
        }
        // Hostname is ASCII (IDN like ä is converted to punycode, e.g. xn--...)
        const hostPattern = /^([\w-]+\.)+[\w-]{2,}$/i;
        return hostPattern.test(parsed.hostname);
      } catch (e) {
        return false;
      }
    },
    normalizeDestinationUrl(value) {
      const raw = String(value || "").trim();
      if (!raw) return "";
      return /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
    },
    resetValidationFlags(rows) {
      rows.forEach((row) => {
        row.validation = {
          destinationUrl: false,
          anchorText: false,
        };
      });
    },
    async goToPayment() {
      const isVerified = await this.ensureUserIsVerifiedBeforeProceed();
      if (!isVerified) return;

      this.validation.order_title = false;
      if (!String(this.form.order_title || "").trim()) {
        this.validation.order_title = true;
        swal.fire({
          icon: "warning",
          text: "Please fill order title first!",
        });
        return;
      }
      const selectedRows = this.mediaRows.filter((row) => row.selected);
      if (!selectedRows.length) {
        swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select at least one media link!",
        });
        return;
      }
      this.resetValidationFlags(selectedRows);
      let errCount = 0;
      let urlErrCount = 0;
      selectedRows.forEach((row) => {
        const destination = String(row.destinationUrl || "").trim();
        const anchor = String(row.anchorText || "").trim();
        if (!destination) {
          row.validation.destinationUrl = true;
          errCount += 1;
        }
        if (!anchor) {
          row.validation.anchorText = true;
          errCount += 1;
        }
        if (destination && !this.isValidURL(destination)) {
          row.validation.destinationUrl = true;
          urlErrCount += 1;
        }
      });
      if (errCount > 0) {
        swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please fill all the required fields!",
        });
        return;
      }
      if (urlErrCount > 0) {
        swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter a valid URL!",
        });
        return;
      }
      const links = this.buildLinksFromRows(selectedRows);
      const linksTotal = links.reduce(
        (sum, link) => sum + (Number(link?.primary_category?.total_cost) || 0),
        0
      );
      localStorage.setItem("order-title", this.form.order_title || "Media Links Order");
      localStorage.setItem("media_link", "true");
      localStorage.setItem("links", LZString.compress(JSON.stringify(links)));
      localStorage.setItem("links-total", String(linksTotal));
      localStorage.setItem("addons-count", "0");
      localStorage.setItem("addons-total", "0");
      localStorage.setItem("sub-total", String(linksTotal));
      localStorage.setItem("order-total", String(linksTotal));
      localStorage.setItem("discount", "0");
      localStorage.removeItem("selected-opportunity");
      localStorage.removeItem("editedOrder");
      localStorage.removeItem("edited-order-flag");
      localStorage.removeItem("discount");
      // EditedOrderLinksPage sets this in sessionStorage, not localStorage.
      sessionStorage.removeItem("payment-flow-type");
      sessionStorage.setItem("payment-flow-type", "normal");
      this.$router.push({
        name: "order-summary",
        query: this.$route.query || {},
      });
    },
    buildLinksFromRows(rows = [], draftOrderId = null) {
      const resolvedDraftOrderId =
        draftOrderId ?? this.draft_order_id ?? localStorage.getItem("draft-order-id") ?? "";
      return rows.map((row, index) => {
        const baseCost = this.toAmount(row?.client_fee ?? row?.price);
        const primaryCategory = this.resolvePrimaryCategory(row, baseCost);
        const normalizedUrl = this.normalizeDestinationUrl(row.destinationUrl);
        const productId = row?.product_id ?? row?.product?.id ?? null;
        const authorityValue = Number(row?.da);
        return {
          // Keep ProductPage normalized link keys for PaymentPage/backend parity.
          id: row?.id ?? `media-${index}`,
          product: { id: productId, name: `DA ${row.da}` },
          product_id: productId,
          product_type: null,
          exact_da_dr: Number.isFinite(authorityValue) ? authorityValue : null,
          exact_da: Number.isFinite(authorityValue) ? authorityValue : null,
          addons: [],
          text: row.anchorText || "",
          anchor_text: row.anchorText || "",
          url: normalizedUrl,
          destination_url: normalizedUrl,
          primary_category: primaryCategory,
          category_id: primaryCategory.id,
          secondry_category: "",
          selected_category: primaryCategory.id ?? "",
          da_fixed_addons: null,
          da_percentage_addons: null,
          fixed_addons: null,
          percentage_addons: null,
          trialDA: false,
          isDaAddonFixed: true,
          isDaAddonPercentage: true,
          isAddon: false,
          isCopy: false,
          isDaAddonActive: true,
          isAddonActive: true,
          draft_order_id: resolvedDraftOrderId,
          order_title: this.form.order_title || "Media Links Order",
          category_name: primaryCategory.name || "",
          link_price: baseCost,
          total: baseCost,
          custom_price_check: false,
          custom_price: baseCost,
          placement_url: "",
          // Media-order specific fields
          website_id: row?.id ?? null,
          authority: Number.isFinite(authorityValue) ? authorityValue : null,
          media_site: row.site,
          media_link: true,
          traffic: row?.traffic ?? null,
          rel_attribute: row?.rel_attribute ?? null,
          sponsored_tag: row?.sponsored_tag ?? null,
          type_of_website: row?.type_of_website ?? row?.website_type ?? null,
          industry:
            row?.industry ??
            row?.industry_name ??
            row?.niche ??
            row?.category_name ??
            primaryCategory?.name ??
            null,
          location: row?.location ?? row?.location_label ?? null,
          sample_post:
            row?.sample_post ??
            row?.sample_post_href ??
            row?.sample_post_display ??
            null,
          turnaround_time: row?.turnaround_time ?? row?.turn_around_time ?? row?.tat ?? null,
        };
      });
    },
    async saveDraftOrder(saveByUser) {
      if (this.form.order_title === "" && saveByUser !== "custom") {
        this.form.order_title = `Draft Autosaved ${this.currentDate}`;
      }
      if (saveByUser === "custom" && this.form.order_title === "") {
        swal.fire({
          icon: "warning",
          text: "Please fill order title first!",
        });
        return;
      }
      try {
        const resolvedDraftOrderId =
          this.draft_order_id ?? localStorage.getItem("draft-order-id") ?? null;
        const draftRows = this.mediaRows.filter((row) => row?.selected);
        const links = this.buildLinksFromRows(draftRows, resolvedDraftOrderId);
        const total = links.reduce(
          (sum, link) => sum + (Number(link?.primary_category?.total_cost) || 0),
          0
        );
        const res = await this.$store.dispatch(
          "Product/saveDraftOrderAction",
          {
            order_type: this.order_type,
            draft_order_id: resolvedDraftOrderId,
            order_title: this.form.order_title,
            total,
            links,
            order_medium: this.medium,
            order_source: this.source,
            package_id: this.package_id,
            invoice_ready: getDraftInvoiceReady({
              order_title: this.form.order_title,
              order_type: this.order_type,
              links,
            }),
          },
          { root: true }
        );
        if (res?.success) {
          this.draft_order_id = res.draft_order_id;
          localStorage.setItem("draft-order-id", res.draft_order_id);
          const routeDraftId = String(this.$route?.params?.id || "");
          const savedDraftId = String(res.draft_order_id || "");
          if (savedDraftId && routeDraftId !== savedDraftId) {
            this.$router.replace({
              name: "media-links-summary",
              params: { id: savedDraftId },
              query: this.$route.query || {},
            });
          }
          if (saveByUser === "custom") {
            toast.success(res.message || "Draft saved successfully.", {
              timeout: 3000,
            });
            this.$router.push({
              path: "/draft-order",
              query: this.$route.query,
            });
          }
        }
      } catch (error) {
        if (saveByUser === "custom") {
          toast.error(error?.response?.data?.message || "Unable to save draft.", {
            timeout: 3000,
          });
        }
      }
    },
    toggleRowMenu(index) {
      this.openMenuIndex = this.openMenuIndex === index ? null : index;
    },
    copyUrlToAllSites(index) {
      const sourceUrl = String(this.mediaRows?.[index]?.destinationUrl || "").trim();
      if (!sourceUrl) {
        this.openMenuIndex = null;
        return;
      }
      this.mediaRows = this.mediaRows.map((row) => ({
        ...row,
        destinationUrl: sourceUrl,
      }));
      this.persistSelectedMediaRows();
      this.openMenuIndex = null;
    },
    deleteRow(index) {
      this.mediaRows.splice(index, 1);
      this.persistSelectedMediaRows();
      this.openMenuIndex = null;
    },
    goBackToMediaLinks() {
      this.$router.push({
        name: "media-links",
        query: this.$route.query || {},
      });
    },
  },

  computed: {
    selectedMediaRows() {
      return this.mediaRows.filter((media) => media.selected);
    },
    selectedMediaTotal() {
      return this.selectedMediaRows.reduce(
        (acc, media) => acc + (Number(media?.price) || 0),
        0
      );
    },
    selectedMediaTotalDisplay() {
      return this.numberFormat(this.selectedMediaTotal || 0) || "0.00";
    },
  },
  watch: {
    mediaRows: {
      deep: true,
      handler() {
        this.persistSelectedMediaRows();
      },
    },
    "form.order_title"(value) {
      localStorage.setItem("order-title", String(value || "").trim());
    },
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>
 